import React, { Component } from "react";
import { Table, Button, Modal, Col, Row, message, Tooltip, Select, Input, Menu, Dropdown, Icon } from "antd";
import axios from "axios";
import "./Pages.css";
import PedidoFiltroForm from '../components/PedidoFiltroForm';
import OrdemServicosPrintModal from "../relatorios/OrdemServicosPrintModal";
import OSPrintModal from "../relatorios/OSPrintModal";
import OSReduzidaPrintModal from "../relatorios/OSReduzidaPrintModal";
import OSPrintCupomModal from "../relatorios/OSPrintCupomModal";
import OrdemServicoForm from '../components/OrdemServicoForm';
import SpinnerForm from '../components/SpinnerForm';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao } from "../utils/LoginManager";
import Colors from '../utils/Colors';
import OrdemServico from '../tutoriais/LancOrdemServico';

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Option } = Select;
const { Search } = Input;


export default class extends Component {
  state = {
    listaRegistros: [],
    carregandoLista: false,
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    totalOS: 0,
    qtdeOS: 0,
    formFiltroVisivel: false,
    formPrintOSVisivel: false,
    formPrintCupomVisivel: false,
    formPrint2ViasVisivel: false,
    idfOS: 0,

    filtros: {
      tipoTela: 'OS',
      buscaOrdem: { campo: 'os_data_emissao', ordem: 'DESC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth() - 6, 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaControle: '',
      buscaPessoa: { key: '0', },
      buscaProduto: { key: '0', },
      buscaGrupoProduto: { key: '0', },
      buscaMarcaProduto: { key: '0', },
      buscaServico: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaSitFin: { key: 'X', },
      buscaVeiculo: '',
    }


  };


  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregandoLista: true, totalOS: 0, qtdeOS: 0 });
    const { pagina, limite } = this.state;
    const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaUsuario, buscaSitFin, buscaOrdem, buscaVeiculo } = this.state.filtros;

    let dataIni = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let dataFim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/ordem_servicos', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          numero: buscaControle,
          veiculo: buscaVeiculo,
          pessoa: buscaPessoa.key,
          usuario: buscaUsuario.key,
          sitFin: String(buscaSitFin.key),
          dataIni,
          dataFim,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data.dados;
        this.setState({
          listaRegistros: data,
          carregandoLista: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),

          totalOS: response.data.totalOS,
          qtdeOS: response.data.qtdeOS,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregandoLista: false,
        });
      });
  };



  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    // console.log('Registro gravar: ', registro);
    let request;
    if (registro.os_idf) {
      request = axios.put(`/ordem_servicos/update/${registro.os_idf}`, registro);
    } else {
      request = axios.post(`/ordem_servicos/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        // console.log('onSalvarClick: ', response.data)

        if (registro.registroNfe) {
          Modal.success({
            title: 'Nota Fiscal',
            okText: 'OK',
            width: '25%',
            content: (
              <div>
                <div>{'Nota TRANSMITIDA com Sucesso'}</div>
                <div>NFe: {response.data.nfe}</div>
                <div>{response.data.chave ? 'Chave: ' + response.data.chave : ''}</div>
              </div>
            ),
          })
        } else {
          if (!registro.os_idf) {
            if (this.state.usuario.par_impr_os === 'COM') {
              this.onImprimirOSClick(response);
            } else if (this.state.usuario.par_impr_os === 'CUP') {
              this.onImprimirCupomClick(response.data.idf);
            } else if (this.state.usuario.par_impr_os === 'RED') {
              this.onImprimir2ViasClick(response.data.idf);
            }
          }
        }
        message.success('Pedido gravado com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        // console.log('onSalvarClick ERRO: ', error.response);
        if ((error.response) && (error.response.status === 401)) {
          if (error.response.data.status) {
            if ((error.response.data.status === 5001) || (error.response.data.status === 5002)) {
              Modal.error({
                title: 'Nota Fiscal',
                okText: 'OK',
                width: '25%',
                content: (
                  <div>
                    <div>Problema com os dados da Nota Fiscal</div>
                    <div>NFe: {error.response.data.nfe}</div>
                    <div>{error.response.data.chave ? 'Chave: ' + error.response.data.chave : ''}</div>
                    <div>{error.response.data.status ? 'ERRO: ' + error.response.data.status + (error.response.data.mensagem ? ' - ' + error.response.data.mensagem : '') : ''}</div>
                  </div>
                )
              })
            } else {
              Modal.error({
                title: 'Emissão Nota Fiscal',
                okText: 'OK',
                width: '25%',
                content: (
                  <div>
                    <div>Erro no Retorno da SEFAZ</div>
                    <div>NFe: {error.response.data.nfe}</div>
                    <div>{error.response.data.chave ? 'Chave: ' + error.response.data.chave : ''}</div>
                    <div>Mensagem: {error.response.data.mensagem}</div>
                    <div>{error.response.data.status ? 'ERRO: ' + error.response.data.status + (error.response.data.mensagem ? ' - ' + error.response.data.mensagem : '') : ''}</div>
                  </div>
                )
              })
            }
          } else {
            Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
          }
        } else {
          Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        }

        this.getListaRegistros();
      })
  }

  onAdicionarClick = () => {
    axios.get(`/caixas/caixaAberto`, { params: { id: 0, cta: 0, data: '', situacao: 'X', } })
      .then(response => {
        const { data } = response;

        this.setState({
          formVisivel: true,
          visualizar: false,
          registroSelecionado: {
            dados: {
              os_idf: 0,
              os_numero: '',
              os_situacao: { key: 'EXE' },
              os_vlr_total: 0,
              os_cliente: {
                key: String(this.state.usuario.par_cliente),
                label: this.state.usuario.pes_nome_cli,
              },
              os_data_emissao: data && data.cx_data ? moment(data.cx_data).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY'),
              os_data_ini: moment().format('DD/MM/YYYY'),
              os_data_fim: moment().format('DD/MM/YYYY'),
              os_usuario: {
                key: this.state.usuario.par_vendedor ? String(this.state.usuario.par_vendedor) : '0',
                label: this.state.usuario.par_vendedor ? this.state.usuario.usu_nome : '',
              },
              os_descricao: '',
              os_solicitante: '',
              os_tipo_doc: {
                key: String(this.state.usuario.par_doc_padrao),
                label: this.state.usuario.td_descricao,
              },
              os_cond_pagto: {
                key: String(this.state.usuario.par_cond_pagto_padrao),
                label: this.state.usuario.td_descricao,
                qtdeParc: this.state.usuario.cp_qtde_parc,
                parcAVista: this.state.usuario.cp_parc_avista,
              },
              oso_defeitos: '',
              oso_laudo: '',

              os_veiculo: 0,
              veic_descricao: '',

              nf_idf_nfe: null,
              nf_numero_nfe: null,
              nf_status_nfe: null,
              nf_modelo_nfe: null,

              nf_idf_nfse: null,
              nf_numero_nfse: null,
              nf_status_nfse: null,
              nf_modelo_nfse: null,

              checkListSelect: [],
              listaProdutos: [],
              listaCheckList: [],
              visualizando: false,
              os_emitir_nfe: false,
              os_emitir_nfse: false,
            }
          },
          registroParcela: {
            tparc_parcela: 0,
            tparc_data_parcela: '',
            tparc_tipo_doc: { key: '0' },
            tparc_conta_corrente: { key: '0' },
            tparc_valor: 0,
            tparc_situacao: { key: 'A', label: 'ABERTO', },
            tparc_obs: '',
            td_descricao: '',
            cc_descricao: '',
            situacao_parcela: '',
            pgto_vlr_desconto: 0,
            pgto_vlr_acrescimo: 0,
            pgto_vlr_pago: 0,
            pgto_vlr_restante: 0,
            pgto_data: '',
            pgto_cta_corrente: '',
          }
        })

      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onEditarClick = (registro, visualizar) => {
    this.setState({ carregando: true });
    axios.get(`/ordem_servicos/show/${registro.os_idf}`)
      .then(response => {
        const { data } = response;

        data.dados.os_situacao = {
          key: String(data.dados.os_situacao),
          label: '',
        }
        data.dados.os_cliente = {
          key: String(data.dados.os_cliente),
          label: data.dados.pes_nome,
        }
        data.dados.os_usuario = {
          key: String(data.dados.os_usuario),
          label: data.dados.usu_nome,
        }

        data.dados.os_cond_pagto = {
          key: (data.listaParcelas.length > 0 && data.listaParcelas[0].tit_cond_pagto) ? String(data.listaParcelas[0].tit_cond_pagto) : '',
          label: (data.listaParcelas.length > 0 && data.listaParcelas[0].cp_descricao) ? String(data.listaParcelas[0].cp_descricao) : '',
          qtdeParc: (data.listaParcelas.length > 0 && data.listaParcelas[0].cp_qtde_parc) ? String(data.listaParcelas[0].cp_qtde_parc) : '',
          parcAVista: (data.listaParcelas.length > 0 && data.listaParcelas[0].cp_parc_avista) ? String(data.listaParcelas[0].cp_parc_avista) : '',
        }

        data.dados.os_tipo_doc = {
          key: (data.listaParcelas.length > 0 && data.listaParcelas[0].tparc_tipo_doc) ? String(data.listaParcelas[0].tparc_tipo_doc) : '',
          label: (data.listaParcelas.length > 0 && data.listaParcelas[0].td_descricao) ? String(data.listaParcelas[0].td_descricao) : '',
        }

        data.dados.os_data_emissao = moment(data.dados.os_data_emissao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        data.dados.os_data_ini = moment(data.dados.os_data_ini, 'YYYY-MM-DD').format('DD/MM/YYYY');
        data.dados.os_data_fim = moment(data.dados.os_data_fim, 'YYYY-MM-DD').format('DD/MM/YYYY');

        data.dados.checkListSelect = data.dados.checkListSelect.map(check => {
          return {
            key: String(check.clos_idf),
            label: check.clos_descricao
          }
        })

        data.dados.visualizando = false;


        let listaProdutos = [];

        for (var x in data.listaProdutos) {
          listaProdutos.push({
            ven_idf: 0,
            venc_idf: 0,
            mi_idf_condicional: 0,
            mi_item: data.listaProdutos[x].mi_item,
            mi_servico: { key: '0' },
            mi_item_Avulso: '',
            mi_seq: listaProdutos.length + 1,
            prod_idf: data.listaProdutos[x].prod_idf,
            pest_qtde: data.listaProdutos[x].pest_qtde,
            prod_grade: data.listaProdutos[x].prod_grade,
            mi_item_tamanho: data.listaProdutos[x].mi_item_tamanho,
            mi_item_cor: data.listaProdutos[x].mi_item_cor,
            ptam_descricao: data.listaProdutos[x].ptam_descricao,
            pcor_descricao: data.listaProdutos[x].pcor_descricao,
            prod_codigo: data.listaProdutos[x].prod_codigo,
            prod_descricao: data.listaProdutos[x].prod_descricao,
            prod_cod_barras: data.listaProdutos[x].prod_cod_barras,
            prod_ncm: data.listaProdutos[x].prod_ncm,
            med_descricao: data.listaProdutos[x].med_descricao,
            mi_qtde: parseFloat(data.listaProdutos[x].mi_qtde),
            osia_custo_unit: 0,
            mi_vlr_unit: parseFloat(data.listaProdutos[x].mi_vlr_unit),
            mi_vlr_venda: parseFloat(data.listaProdutos[x].mi_vlr_venda),
            mi_vlr_venda_min: parseFloat(data.listaProdutos[x].mi_vlr_venda_min),
            mi_perc_desc: parseFloat(data.listaProdutos[x].mi_perc_desc),
            mi_vlr_desc: parseFloat(data.listaProdutos[x].mi_vlr_desc),
            mi_vlr_acres: parseFloat(data.listaProdutos[x].mi_vlr_acres),
            mi_vlr_total: parseFloat(data.listaProdutos[x].mi_vlr_total),
            mi_calc_estoque: parseFloat(data.listaProdutos[x].mi_calc_estoque),
            tipoItem: 'P',
          });
        };

        for (var x in data.listaServicos) {
          listaProdutos.push({
            ven_idf: 0,
            venc_idf: 0,
            mi_idf_condicional: 0,
            mi_item: { key: '0' },
            mi_servico: data.listaServicos[x].osis_servico,
            mi_item_Avulso: '',
            mi_seq: listaProdutos.length + 1,
            prod_idf: '',
            pest_qtde: 0,
            prod_grade: '',
            mi_item_tamanho: '',
            mi_item_cor: '',
            ptam_descricao: '',
            pcor_descricao: '',
            prod_codigo: '',
            prod_descricao: data.listaServicos[x].serv_descricao,
            prod_cod_barras: '',
            prod_ncm: '',
            med_descricao: '',
            mi_qtde: parseFloat(data.listaServicos[x].osis_qtde),
            osia_custo_unit: 0,
            mi_vlr_unit: parseFloat(data.listaServicos[x].osis_vlr_unit),
            mi_vlr_venda: parseFloat(data.listaServicos[x].osis_vlr_unit),
            mi_vlr_venda_min: parseFloat(data.listaServicos[x].osis_vlr_unit),
            mi_perc_desc: parseFloat(data.listaServicos[x].osis_perc_desconto),
            mi_vlr_desc: parseFloat(data.listaServicos[x].osis_vrl_desconto),
            mi_vlr_acres: 0,
            mi_vlr_total: parseFloat(data.listaServicos[x].osis_vlr_total),
            mi_calc_estoque: 0,
            tipoItem: 'S',
          });
        };

        for (var x in data.listaAvulsos) {
          listaProdutos.push({
            ven_idf: 0,
            venc_idf: 0,
            mi_idf_condicional: 0,
            mi_item: { key: '0' },
            mi_servico: 0,
            mi_item_Avulso: data.listaAvulsos[x].osia_descricao,
            mi_seq: listaProdutos.length + 1,
            prod_idf: '',
            pest_qtde: 0,
            prod_grade: '',
            mi_item_tamanho: '',
            mi_item_cor: '',
            ptam_descricao: '',
            pcor_descricao: '',
            prod_codigo: '',
            prod_descricao: data.listaAvulsos[x].osia_descricao,
            prod_cod_barras: '',
            prod_ncm: '',
            med_descricao: '',
            mi_qtde: parseFloat(data.listaAvulsos[x].osia_qtde),
            osia_custo_unit: parseFloat(data.listaAvulsos[x].osia_custo_unit),
            mi_vlr_unit: parseFloat(data.listaAvulsos[x].osia_vlr_unit),
            mi_vlr_venda: parseFloat(data.listaAvulsos[x].osia_vlr_unit),
            mi_vlr_venda_min: parseFloat(data.listaAvulsos[x].osia_vlr_unit),
            mi_perc_desc: 0,
            mi_vlr_desc: 0,
            mi_vlr_acres: 0,
            mi_vlr_total: parseFloat(data.listaAvulsos[x].osia_vlr_total),
            mi_calc_estoque: 0,
            tipoItem: 'A',
          });
        };

        data.listaProdutos = listaProdutos;


        let listaCheckList = [];
        for (var x in data.listaCheckList) {
          listaCheckList.push({
            clos_idf: data.listaCheckList[x].clos_idf,
            clos_descricao: data.listaCheckList[x].clos_descricao,
            check: data.listaCheckList[x].oscl_check,
            obs: data.listaCheckList[x].oscl_obs,
          });
        };
        data.listaCheckList = listaCheckList;


        this.setState({
          formVisivel: true,
          registroSelecionado: {
            ...data,
            visualizar,
            os_emitir_nfe: false,
            os_emitir_nfse: false,
          },
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregandoLista: true });
        axios.delete(`/ordem_servicos/delete/${registro.os_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.os_idf === registro.os_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregandoLista: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregandoLista: false,
            })
            if (error.response.status === 412) {
              Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
            } else {
              Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
            }
          })
      }
    })
  };

  onImprimirOSClick = (registro) => {
    // this.setState({
    //   idfOS: os_idf,
    //   formPrintOSVisivel: true,
    // });

    this.setState({ carregando: true });
    const reg = {
      os_idf: String(registro.os_idf),
    };
    axios.post('/ordem_servicos/montaPDF', reg)
      .then(response => {
        const { data } = response;
        const file_url = 'https://api.fastgestor.plenasistemas.inf.br/image/emp' + registro.os_empresa + '/pdf/' + data.nomeArq;
        window.open(file_url, '_blank')
      }).catch(ex => {
        Modal.warning({ title: 'Aviso!', content: 'Não foi possível localizar a O.S', });
        this.setState({ carregando: false });
        console.warn(ex);
      });
    this.setState({
      carregando: false,
    })
  };

  onImprimirCupomClick = (os_idf) => {
    this.setState({
      idfOS: os_idf,
      formPrintCupomVisivel: true,
    });
  };

  onImprimir2ViasClick = (os_idf) => {
    this.setState({
      idfOS: os_idf,
      formPrint2ViasVisivel: true,
    });
  };

  onCancelarPrintClick = () => {
    this.setState({
      idfOS: 0,
      formPrintOSVisivel: false,
      formPrintCupomVisivel: false,
      formPrint2ViasVisivel: false,
    })
  }




  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    this.setState({ [id]: value });
  };


  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaControle: String(this.state.filtros.buscaControle),
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaMarcaProduto: this.state.filtros.buscaMarcaProduto,
        buscaServico: this.state.filtros.buscaServico,
        buscaSitFin: this.state.filtros.buscaSitFin,
        buscaVeiculo: this.state.filtros.buscaVeiculo,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };


  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };




  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }


  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {getTemPermissao('OrdemServicosPage', 'editar') ? (
          <span>
            <Tooltip title="Editar">
              <Button type="primary" size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
            </Tooltip>
          </span>
        ) : (
          <span>
            <Tooltip title="Visualizar">
              <Button type="ghost" size="small" onClick={() => this.onEditarClick(registro, true)} icon="eye" />
            </Tooltip>
          </span>
        )}
        {getTemPermissao('OrdemServicosPage', 'excluir') ? (
          <span>
            <Tooltip title="Excluir">
              <Button type="danger" size="small" disabled={registro.nf_idf} onClick={() => this.onExcluirClick(registro)} icon="delete" />
            </Tooltip>
          </span>
        ) : null}

        <span>
          <Tooltip title="Impressão">
            <Dropdown overlay={
              <Menu >
                <Menu.Item key="1" onClick={() => this.onImprimirOSClick(registro)}>Completa</Menu.Item>
                <Menu.Item key="2" onClick={() => this.onImprimir2ViasClick(registro.os_idf)}>2 Vias</Menu.Item>
                <Menu.Item key="3" onClick={() => this.onImprimirCupomClick(registro.os_idf)}>Cupom</Menu.Item>
                {(registro.nf_idf && ((registro.nf_status === 1) || (registro.nf_status === 4))) ?
                  (<Menu.Item key="2" onClick={() => this.onImprimirNFeClick(registro)}>DANFE NFe</Menu.Item>)
                  : null}
              </Menu>
            } placement="bottomRight">
              <Button type="ghost"><Icon type="printer" /></Button>
            </Dropdown>
          </Tooltip>
        </span>
      </ButtonGroup>
    );
  };


  onChangeSituacao = (registro, event) => {
    this.setState({ carregando: true })
    axios.
      put(`/ordem_servicos/mudaSituacao/${registro.os_idf}/${event}`)
      .then(response => {
        registro.os_situacao = event;
        this.setState({
          listaRegistros: this.state.listaRegistros.concat([]),
          carregando: false
        })
      }).catch(error => {
        console.error(error.response);
        this.setState({ carregando: false })
      })
  };

  renderSitOS = (sit, registro) => {
    const os_situacao = { key: sit }
    return (
      <Select
        style={{ width: 150 }}
        onChange={situcao => this.onChangeSituacao(registro, situcao)}
        defaultValue={sit}
      >
        <Option value="ESP">ESPERA</Option>
        <Option value="AGE">AGENDAMENTO</Option>
        <Option value="EXE">EXECUÇÃO</Option>
        <Option value="FIN">FINALIZADA</Option>
        <Option value="ENT">ENTREGUE</Option>
      </Select>

    );
  };

  renderSitFinanc = (sit) => {
    return (
      <span> {!sit ? 'VAZIO' : sit === 'P' ? 'PAGO' : 'ABERTO'} </span>
    );
  };

  renderValor = (vlr, registro) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderNFe = (text, registro) => {
    return (
      <span> {registro.nf_numero_nfe ? registro.nf_numero_nfe + ' / ' + registro.situacao_nfe.substring(0, 3) : ''} </span>
    );
  };

  renderNFSe = (text, registro) => {
    return (
      <span> {registro.nf_numero_nfse ? registro.nf_numero_nfse + ' / ' + registro.situacao_nfse.substring(0, 3) : ''} </span>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })

  renderVendedor = (usu_nome) => {
    return (
      <span>{usu_nome.substring(0, 10)}</span>
    );
  };


  onBuscar = (texto) => {
    this.setState({
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaControle: String(texto),
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaMarcaProduto: this.state.filtros.buscaMarcaProduto,
        buscaServico: this.state.filtros.buscaServico,
        buscaSitFin: this.state.filtros.buscaSitFin,
        buscaVeiculo: this.state.filtros.buscaVeiculo,
      }
    },
      this.getListaRegistros);
  };



  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      filtros, formFiltroVisivel, formPrintOSVisivel, formPrintCupomVisivel, formPrint2ViasVisivel,
      total, pagina, limite } = this.state;
    const { buscaControle } = this.state.filtros;

    // console.log('OrdemServicosPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="tituloPage">Ordens de Serviços</span>
          <div>
            <Tooltip title="Video de Ajuda">
              <Button
                type="primary"
                onClick={() => window.open('https://www.youtube.com/watch?v=zfoLi03Bkus&list=PLpe5WZ31yjQa5k3LuG7hBzmY1J-mOW3zz&index=6', '_blank')}
                icon="youtube"
                className="botao-ajuda"
              ></Button>
            </Tooltip>
            <Tooltip title="Ajuda">
              <Button
                type="primary"
                onClick={() => this.setState({ modalOpen: true })}
                icon="question"
                className="botao-ajuda"
              ></Button>
            </Tooltip>
          </div>
        </div>
        <div className="divider-page1" />

        <div className="pageFiltro" style={{ height: 50 }}>
          <Col xs={24} >
            <Col xs={12}>
              {getTemPermissao('OrdemServicosPage', 'novo') ? (
                <Col xs={2} style={{ width: 110 }}>
                  <Button
                    type="primary"
                    onClick={this.onAdicionarClick}
                    className="botao-primary"
                  >
                    Adicionar
                  </Button>
                </Col>
              ) : null}

              <Col xs={2} style={{ width: 110 }}>
                <Button
                  type="primary"
                  onClick={this.onAbrirFiltroClick}
                  className="botao-primary"
                  style={{ marginRight: 15 }}
                >
                  Filtrar
                </Button>
              </Col>

              <Col xs={2} style={{ width: 110 }}>
                <OrdemServicosPrintModal
                  filtros={filtros}
                  totalOS={this.state.totalOS}
                  qtdeOS={this.state.qtdeOS}
                />
              </Col>

              <Col xs={6}>
                <Search
                  placeholder="Nº O.S"
                  onSearch={this.onBuscar}
                  enterButton
                  className="pageFiltro-busca"
                />
              </Col>

              <PedidoFiltroForm
                visivel={formFiltroVisivel}
                onFiltrarClick={this.onFiltrarClick}
                onCancelarFiltroClick={this.onCancelarFiltroClick}
                filtros={filtros}
              />

              <OrdemServico
                isOpen={this.state.modalOpen}
                onClose={() => this.setState({ modalOpen: false })}
              />
              <SpinnerForm visivel={carregando} texto={'Carregando Aguarde...'} />
            </Col>

            <Col xs={24} md={8} style={{ height: 65, padding: 5, marginTop: -25 }}>
              <Col xs={24} md={12} style={{ height: 65, padding: 5 }}>
                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                  <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                      Qtde O.S
                    </span>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Row style={{ marginTop: -5 }}>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.state.qtdeOS}</span>
                    </Row>
                  </Row>
                </div>
              </Col>
              <Col xs={24} md={12} style={{ height: 65, padding: 5 }}>
                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                  <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                      Valor Total
                    </span>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Row style={{ marginTop: -5 }}>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.totalOS)}</span>
                    </Row>
                  </Row>
                </div>
              </Col>
            </Col>
            {/* <Col xs={24} sm={7} style={{ background: Colors.background, padding: 5, marginTop: -10 }}>
              <Col xs={24} sm={11} style={{ marginRight: 5, textAlign: "center", background: "white", marginLeft: 5 }} >
                <Row><span style={{ fontWeight: "bold" }}>Qtde O.S</span></Row>
                <Row><span>{this.state.qtdeOS}</span></Row>
              </Col>
              <Col xs={24} sm={12} style={{ marginRight: 0, textAlign: "center", background: "white" }} >
                <Row><span style={{ fontWeight: "bold" }}>Valor Total</span></Row>
                <Row><span>R$ {this.renderValor(this.state.totalOS)}</span></Row>
              </Col>
            </Col> */}

          </Col>

          <OrdemServicoForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />

          <OSPrintModal
            visivel={formPrintOSVisivel}
            os_idf={this.state.idfOS}
            tipoVenda="OS"
            onCancelarPrintClick={this.onCancelarPrintClick}
          />

          <OSPrintCupomModal
            visivel={formPrintCupomVisivel}
            os_idf={this.state.idfOS}
            tipoVenda="OS"
            onCancelarPrintClick={this.onCancelarPrintClick}
          />

          <OSReduzidaPrintModal
            visivel={formPrint2ViasVisivel}
            os_idf={this.state.idfOS}
            tipoVenda="OS"
            onCancelarPrintClick={this.onCancelarPrintClick}
          />

        </div>



        <div style={{ paddingTop: 0 }}>
          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            rowKey={(registro => registro.os_idf)}
          // scroll={{ x: 600, y: false }}
          >
            <Column
              key="os_numero"
              dataIndex="os_numero"
              title={this.renderTitulo("Número")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={80}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="os_data_emissao"
              dataIndex="os_data_emissao"
              title={this.renderTitulo("Emissão")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={140}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="pes_nome"
              dataIndex="pes_nome"
              title={this.renderTitulo("Cliente")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={120}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="os_descricao"
              dataIndex="os_descricao"
              title={this.renderTitulo("Descrição")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={150}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="usu_nome"
              dataIndex="usu_nome"
              title={this.renderTitulo("Vendedor")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderVendedor}
              width={80}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="os_vlr_total"
              dataIndex="os_vlr_total"
              title={this.renderTitulo("Valor Total")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderValor}
              width={90}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="tit_situacao"
              dataIndex="tit_situacao"
              title={this.renderTitulo("Sit. Financ.")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderSitFinanc}
              width={90}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="nf_numero"
              dataIndex="nf_numero"
              title={this.renderTitulo("NFe")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderNFe}
              width={80}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="situacao_nota"
              dataIndex="situacao_nota"
              title={this.renderTitulo("NFSe")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderNFSe}
              width={80}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="os_situacao"
              dataIndex="os_situacao"
              title={this.renderTitulo("Situação O.S")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderSitOS}
              width={100}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="acoes"
              title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
              render={this.renderAcoes}
              width={120}
              align="center"
              className="listaCadastro"
            />
          </Table>
        </div>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/OrdemServicosPage.js